export const SHIPMENT = [
    { name: 'Shipment', value: 'under deck' },
    { name: 'Shipment', value: 'on deck' },
    { name: 'Shipment', value: 'on/under deck' },
];

export const CRADLES_TO_BE_FOR = [
    { name: 'Cradles to be for', value: 'Charterer\'s account' },
    { name: 'Cradles to be for', value: 'Charterer\'s account, and time' },
    { name: 'Cradles to be for', value: 'Charterer\'s account, risk and time' },
    { name: 'Cradles to be for', value: 'Owner\'s account' },
    { name: 'Cradles to be for', value: 'Owner\'s account, and time' },
    { name: 'Cradles to be for', value: 'Owner\'s account, risk and time' },
];



// WEBPACK FOOTER //
// ./app/constants/weightVolume.js